module.exports = require("novnc-node");


//////////////////
// WEBPACK FOOTER
// external "novnc-node"
// module id = 3
// module chunks = 0 1